import React from 'react';
import styled from 'styled-components';
import { useState, useEffect } from 'react';
import SentTable from './SentTable'
import UnivReqFlow from '../IssueReq/UnivReqFlow'
import ReturnReqFlow from '../UserAssetReturnReq/ReturnReqFlow'
import BoReturnReqFlow from '../BoAssetReturnReq/BoReturnReqFlow'

const Container = styled.div``
const Wrapper = styled.div``

const Sent = ({ subTabValue }) => {

  const [row, setRow] = useState('')
  const [changepage, setChangepage] = useState([true, false, false])

  const handleEditclick = (e, row, reqtype) => {
    setRow(row)
    // Show appropriate flow component based on request type
    setChangepage([false, true, false])
  }

  const handleBack = () => {
    setChangepage([true, false, false])
  }

  // Helper function to determine if this is an asset return request
  const isAssetReturnRequest = (row) => {
    return ['Asset_Return',
            "Ind_Asset_Return",
            "IndAsset_Rtrn_Str_Direct",
            "Ind_Asset_Return_Bo",
            "Asset_Return_Store_Via_BO",
            "Asset_Return_Bo"
          ]?.includes(row?.req_type);
  }

  // Helper function to determine if this is a BO return request
  const isBoReturnRequest = (row) => {
    return ['BO_User_Transfer', 
            'BO_Store_Return'
          ]?.includes(row?.req_type);
  }
  console.log(isBoReturnRequest(row))
  console.log(isAssetReturnRequest(row))
  return (
    <Container>
      <Wrapper>
        {changepage[0] && <SentTable subTabValue={subTabValue} handleEditclick={handleEditclick} />}
        {changepage[1] && (
          <>
            <div 
              onClick={handleBack} 
              style={{
                cursor: 'pointer',
                color: '#1976d2',
                display: 'flex',
                alignItems: 'center',
                marginBottom: '20px',
                width: 'fit-content'
              }}
            >
              ◀ Back to All Sent Requests
            </div>
            {/* Conditionally render the appropriate flow component */}
            {isAssetReturnRequest(row) ? (
              <ReturnReqFlow row={row} />
            ) : isBoReturnRequest(row) ? (
              <BoReturnReqFlow row={row} />
            ) : (
              <UnivReqFlow row={row} />
            )}
          </>
        )}
        {/* {changepage[2] && <HandoverSentForm reqid={reqid} setChangepage={setChangepage} />} */}
      </Wrapper>
    </Container>
  )
}

export default Sent